module.exports = __webpack_public_path__ + "static/media/planning_title_zh.4ed8d6a6.png";